import * as React from 'react';
import { cn } from '../../lib/utils';

interface FormSectionProps {
  title: string;
  desc?: string;
  children: React.ReactNode;
  aside?: React.ReactNode;
}

export const FormSection = React.forwardRef<HTMLElement, FormSectionProps>(
  ({ title, desc, children, aside }, ref) => (
    <section
      ref={ref}
      className="grid grid-cols-1 gap-x-10 gap-y-5 border-t border-line py-7 first:border-t-0 first:pt-0 lg:grid-cols-[230px_1fr]"
    >
      <div>
        <h3 className="font-display text-[15px] font-semibold text-ink">{title}</h3>
        {desc && <p className="mt-1 text-xs leading-relaxed text-muted">{desc}</p>}
        {aside}
      </div>
      <div className="grid grid-cols-1 gap-x-5 gap-y-4 sm:grid-cols-2">{children}</div>
    </section>
  )
);
FormSection.displayName = 'FormSection';

interface FieldProps {
  label: string;
  hint?: string;
  required?: boolean;
  span?: 1 | 2;
  children: React.ReactNode;
  tag?: React.ReactNode;
}

export const Field = ({ label, hint, required, span, children, tag }: FieldProps) => (
  <label className={cn('flex flex-col gap-1.5', span === 2 && 'sm:col-span-2')}>
    <span className="flex items-center gap-2 text-xs font-semibold text-ink">
      {label}
      {required && <span className="text-rose">*</span>}
      {tag}
    </span>
    {children}
    {hint && <span className="text-xs leading-snug text-faint">{hint}</span>}
  </label>
);

interface FieldBlockProps {
  label: string;
  hint?: string;
  span?: 1 | 2;
  children: React.ReactNode;
}

export const FieldBlock = ({ label, hint, span, children }: FieldBlockProps) => (
  <div className={cn('flex flex-col gap-1.5', span === 2 && 'sm:col-span-2')}>
    <span className="flex items-center gap-2 text-xs font-semibold text-ink">{label}</span>
    {children}
    {hint && <span className="text-xs leading-snug text-faint">{hint}</span>}
  </div>
);
